import { EditLine } from "@dropbox/dig-icons/assets";
import { useCombinedOnboardingInfo } from "@mirage/growth/onboarding/hooks/useCombinedOnboardingInfo";
import { SuggestionTile } from "@mirage/mosaics/SuggestionTile/SuggestionTile";
import { ProfilingQuestionKindOfWorkAnswer } from "@mirage/service-onboarding-surveys/service/onboarding-surveys/self-serve-profiling";
import { openURL } from "@mirage/service-platform-actions";
import type { PreConfiguredTemplateID } from "@mirage/shared/compose/assist-template";
import {
  getDeepLinkURL,
  RouteToSlug,
} from "@mirage/shared/fss-bridge/bridgeRouting";
import i18n from "@mirage/translations";

interface RoleTemplateMapping {
  text: string;
  templateId: PreConfiguredTemplateID;
}

const getTemplateInfoByRole = (
  role: ProfilingQuestionKindOfWorkAnswer | null,
): RoleTemplateMapping => {
  switch (role) {
    case ProfilingQuestionKindOfWorkAnswer.Creative:
    case ProfilingQuestionKindOfWorkAnswer.Marketing:
      return {
        text: i18n.t("promotion_write_marketing_blog_post"),
        templateId: "marketing_blog_post",
      };
    case ProfilingQuestionKindOfWorkAnswer.Sales:
      return {
        text: i18n.t("promotion_write_sales_outreach_email"),
        templateId: "sales_outreach_email",
      };
    default:
      return {
        text: i18n.t("promotion_write_status_report"),
        templateId: "status_report",
      };
  }
};

export const PromotionWriteWithTemplateChip = () => {
  const { role, loading } = useCombinedOnboardingInfo();

  if (loading) {
    return null;
  }

  const { text, templateId } = getTemplateInfoByRole(role);

  const handleClick = () => {
    openURL(
      getDeepLinkURL(RouteToSlug.WRITE_WITH_TEMPLATE, {
        templateId,
      }),
    );
  };

  return (
    <div data-testid="promotion-write-with-template-chip">
      <SuggestionTile
        text={text}
        display={"inline"}
        size="medium"
        onClick={handleClick}
        customIconSrc={EditLine}
        isExternalLink={true}
      />
    </div>
  );
};
